export const stringAvatar = (name: string) =>
  name.split(' ').length > 1
    ? `${name.split(' ')[0][0].toUpperCase()}${name
        .split(' ')[1][0]
        .toUpperCase()}`
    : `${name[0].toUpperCase()}${name[1].toUpperCase()}`
